import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
    position: 'relative',
    padding: theme.spacing(14, 0 ,14, 0),
    background: `linear-gradient(180deg, ${theme.palette.background.primary}) 0%, rgba(17, 17, 17, 0.00) 100%), ${theme.palette.background.primary})`,
    [theme.breakpoints.down('lg')]: {
     padding: theme.spacing(8, 0),
    },
  '& .ORTBGPattern': {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: theme.typography.pxToRem(205),
    zIndex: 1,
    maskImage: `linear-gradient(
        to bottom,
         ${alpha(theme.palette.common.black, 0.7)} 50%,
         ${alpha(theme.palette.common.black, 0.01)} 100%
      )`,
  },
'& .OTPSDesc':{
  maxWidth: theme.spacing(85),
},
}));

export default StyledBox;
